import { render, staticRenderFns } from "./SorterList.vue?vue&type=template&id=82a4425e&scoped=true"
import script from "./SorterList.vue?vue&type=script&lang=js"
export * from "./SorterList.vue?vue&type=script&lang=js"
import style0 from "./SorterList.vue?vue&type=style&index=0&id=82a4425e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a4425e",
  null
  
)

export default component.exports